import React from 'react';
import Plx from 'react-plx';
import styled from '@emotion/styled';
import { breakpoints as breakpoint } from '../../utils/style';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import GetWindowWidth from './GetWindowWidth';

const ParallaxContainer = styled('div')`
  position: relative;
  z-index: -100;
  .bg {
    display: block;
    width: 90%;
    position: fixed;
    top: 0;
    color: #000;
  }
  .bg-one {
    top: auto;
    bottom: -15px;
    left: 0;
    right: 0;
    width: 80%;
    .gatsby-image-wrapper {
      margin-left: -90px;
    }

    .gatsby-image-wrapper {
      margin-left: -60px;
    }
  }
  .bg-two {
    right: 0;
    top: -50px;
    width: 100%;
    .gatsby-image-wrapper {
      margin-left: -10%;
    }
  }
  @media(max-width: ${breakpoint.lg}) {
    .bg-two {
      top: -200px;
    }
  }
  @media(max-width: ${breakpoint.md}) {
    .bg-one {
      top: -40px;
      width: 100%;
    }
  }
`;

const Parallax = () => {
  const image1ParallaxData = [
    {
      start: 0,
      duration: 4500,
      properties: [
        {
          startValue: 150,
          endValue: 210,
          property: "translateY",
        },
      ],
    },
    {
      start: 800,
      duration: 5000,
      properties: [
        {
          startValue: 160,
          endValue: -1200,
          property: "translateY",
        },
      ],
    },
  ];

  const image2ParallaxData = [
    {
      start: -200,
      duration: 5500,
      properties: [
        {
          startValue: -450,
          endValue: 1000,
          property: "translateY",
        },
      ],
    },
  ];

  return (
    <StaticQuery
      query={graphql`
        query {
          parallax1: file(relativePath: { eq: "parallax/BG-front.png" }) {
            childImageSharp {
              fluid(maxWidth: 1920) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          parallax2: file(relativePath: { eq: "parallax/BG-back.png" }) {
            childImageSharp {
              fluid(maxWidth: 1920) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          parallax1_mobile: file(relativePath: { eq: "parallax/BG-front.png" }) {
            childImageSharp {
              fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          parallax2_mobile: file(relativePath: { eq: "parallax/BG-back.png" }) {
            childImageSharp {
              fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={data => {
        const windowWidth = GetWindowWidth();
        const isDesktop = windowWidth > 600;
        return (
          <ParallaxContainer>
            <Plx className="bg bg-two" parallaxData={image2ParallaxData}>
              {isDesktop ?
                <Img
                  alt="HOLIDAYPALACE Background 2"
                  fluid={data.parallax2.childImageSharp.fluid}
                  fadeIn={false}
                  loading='eager'
                />
                :<Img
                  alt="HOLIDAYPALACE Background 2"
                  fluid={data.parallax2_mobile.childImageSharp.fluid}
                  fadeIn={false}
                  loading='eager'
                />
              }
            </Plx>
            <Plx className="bg bg-one" parallaxData={image1ParallaxData}>
              {isDesktop ?
                <Img
                  alt="HOLIDAYPALACE Background 1"
                  fluid={data.parallax1.childImageSharp.fluid}
                  fadeIn={false}
                  loading='eager'
                />
                :<Img
                  alt="HOLIDAYPALACE Background 1"
                  fluid={data.parallax1_mobile.childImageSharp.fluid}
                  fadeIn={false}
                  loading='eager'
                />
              }
            </Plx>
          </ParallaxContainer>
        )
      }}
    />
  );
};

export default Parallax;
